module.exports = __webpack_public_path__ + "media/images/dashboards/history_loader-93e0b24348ad79aa89e3a05ea80ede9c.gif";